import { createFileRoute } from '@tanstack/react-router';

import Table from '~/toplist/Table';

export const Route = createFileRoute('/_protected/table')({
  component: Table,
});
